module.exports = __webpack_public_path__ + "static/media/avatar13.6f659ca0.png";